<style>

.time{
  font-size: 17px;
}

</style>

<div class="time">{rendered}</div>

<script>

export let start = 0;
export let end = 0;

$:{
  if (start || end) {
    render();
  }
}


const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

let rendered = "updating...";
function render() {
	const now = new Date();
	const sd = new Date();
	sd.setTime(start * 1000);
	const ed = new Date();
	ed.setTime(end * 1000);

	if ( now.getMonth() == sd.getMonth() && now.getFullYear() == sd.getFullYear() && now.getDate() + 1 == sd.getDate() ) {
		rendered = "Tomorrow" + calcTime(sd, ed);
	} else if ( now.getMonth() == sd.getMonth() && now.getFullYear() == sd.getFullYear() && now.getDate() == sd.getDate() ) {
		rendered = "Today" + calcTime(sd, ed);
	} else if ( now.getMonth() == sd.getMonth() && now.getFullYear() == sd.getFullYear() && now.getDate() - 1 == sd.getDate() ) {
		rendered = "Yesterday" + calcTime(sd, null);
	} else if ( sd.getFullYear() < now.getFullYear() ) {
		rendered = MONTH_NAMES[ sd.getMonth() ] + " " + sd.getDate() + ", " + sd.getFullYear() + calcTime(sd, ed);
	} else {
		rendered = DAY_NAMES[ sd.getDay() ] + ", " + MONTH_NAMES[ sd.getMonth() ] + " " + sd.getDate() + calcTime(sd, ed);
	}
  
}


function calcTime(startDate, endDate) {
  
  // console.log("startDate:", startDate);
  // console.log("endDate:", endDate);
  
  let out = " @ ";
  
  let hour = startDate.getHours();
  let half = "am";
  if (hour > 12) {
    hour = hour - 12;
    half = "pm";
  }
  
  let minute = startDate.getMinutes();
  if (minute < 10) {
    minute = "0" + minute;
  }
  out += hour + ":" + minute + half;
  
  if (endDate != null) {
    out += " to ";
    
    hour = endDate.getHours();
    half = "am";
    if (hour > 12) {
      hour = hour - 12;
      half = "pm";
    }
    
    let minute = endDate.getMinutes();
    if (minute < 10) {
      minute = "0" + minute;
    }
    out += hour + ":" + minute + half;
    
  }
  
  return out;
}

</script>